var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.75C9.65279 7.75 7.75 9.65279 7.75 12C7.75 13.4837 8.51031 14.7899 9.66257 15.5501L12.9589 7.85854C12.6507 7.78751 12.3298 7.75 12 7.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.5569 6.46337C13.0617 6.32438 12.5395 6.25 12 6.25C8.82436 6.25 6.25 8.82436 6.25 12C6.25 14.1033 7.37928 15.9428 9.0646 16.9453L8.31064 18.7046C8.14747 19.0853 8.32384 19.5262 8.70456 19.6894C9.08528 19.8525 9.52619 19.6762 9.68936 19.2954L10.4431 17.5367C10.9383 17.6757 11.4604 17.75 12 17.75C13.8817 17.75 15.5523 16.8454 16.6 15.4504C16.8488 15.1192 16.782 14.6491 16.4508 14.4003C16.1196 14.1516 15.6495 14.2184 15.4007 14.5496C14.624 15.5835 13.39 16.25 12 16.25C11.6702 16.25 11.3493 16.2124 11.0411 16.1414L14.3375 8.44981C14.7466 8.71977 15.1065 9.05873 15.4007 9.45043C15.6495 9.78162 16.1196 9.84844 16.4508 9.59968C16.782 9.35091 16.8488 8.88076 16.6 8.54957C16.1494 7.94965 15.5836 7.44041 14.9353 7.05482L15.6894 5.29544C15.8525 4.91472 15.6762 4.47381 15.2954 4.31064C14.9147 4.14747 14.4738 4.32384 14.3106 4.70456L13.5569 6.46337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCent);
export default __webpack_public_path__ + "static/media/cent.b84199d7a0fe9b09daeb5e7871ef4245.svg";
export { ForwardRef as ReactComponent };